import { ChildModel, ModelBase } from 'store/model-base';
import { StatementDataLine } from './line';
import { DataPlanType } from 'my-account/constants';
import { DeviceType } from 'core/constants';

export class StatementDataPlan extends ModelBase {
    public static storeName: string = 'statementDataPlan';

    public id: number;
    public planType: DataPlanType;
    public dataIncluded: number;
    public dataUsage: number;
    public planCharge: StatementPlanCharge;
    public charges: StatementPlanCharge[];
    public lines: StatementDataLine[];
    public isUnlimited: boolean;
    public isSharedByTheGig: boolean;
    public isByTheGig: boolean;
    public isWatchData: boolean;
    public name: string;
    public cost: number;
    public lineCount: number;
    public isTabletDataPlan: boolean;
    public prorated: boolean;

    public static create<T extends ModelBase>(data: ApiResponse): T {
        data.isUnlimited = data.planType && data.planType === DataPlanType.UNLIMITED;
        data.isSharedByTheGig = data.planType && data.planType === DataPlanType.BY_THE_GIG_SHARED;
        data.isByTheGig = data.planType && data.planType === DataPlanType.BY_THE_GIG_SHARED;
        data.isWatchData = data.planType && data.planType === DataPlanType.SMART_WATCH;
        data.name = data.planCharge ? data.planCharge.name : '';
        data.lineCount = data.lines && data.lines.length;
        data.cost = data.planCharge ? data.planCharge.cost : 0;
        data.isTabletDataPlan = data.lines && data.lines[0].deviceType === DeviceType.TABLET;
        data.prorated = data.charges.some((charge: StatementPlanCharge) => charge.prorated);

        return super.create<T>(data);
    }

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'lines',
            model: StatementDataLine
        }];
    }
}
